const inputRangeDom = require("./input_range.html")
const calculatorDom = require("./calculator.html")
const modalButtonDom = require("./modal_button.html")

class BudgetInputBuilder {
  constructor(target) {
    this.target = target;
    this.targetWrapper = this.target.closest('dd');
    this.inputRange = $( inputRangeDom );
    this.calculatorModal = $( calculatorDom );
    this.modalButton = $( modalButtonDom );
  }

  setup() {
    this.targetWrapper.append(this.inputRange);
    this.targetWrapper.append(this.modalButton);
    this.inputRange.on('change input',(e) => {
      this.target.val(this.inputRange.val());
    });

    this.inputRange.val(this.target.val());

    this.target.on('change input', (e) => {
      this.inputRange.val(this.target.val());
    });

    this.setupCalculator()
  }

  setupCalculator() {
    $( 'body' ).append(this.calculatorModal);

    this.calculatorModal.find('#income').off('input').on('input', () => {
      if(this.calculatorModal.find('#income').val() === '0' || $('#income').val() === '')
      {
        this.calculatorModal.find('#budgetValidate').prop('disabled', true);
      }
      else
      {
        this.calculatorModal.find('#budgetValidate').prop('disabled', false);
      }
      this.calculateLoanCapacity();
    });

    this.calculatorModal.find('#apport').off('input').on('input', () => {
      this.calculateLoanCapacity();
    });

    this.calculatorModal.find('#duration').off('change').on('change', () => {
      this.calculateLoanCapacity();
    });

    this.calculatorModal.find('#budgetValidate').off('click').one('click', () => {
      var value = this.calculatorModal.find('#loanCapacity').data('budget');
      this.target.val(value);
        this.calculatorModal.modal('hide');
      this.target.change();
    })
  }

  calculateLoanCapacity() {
    var monthly = $('#income').val();
    var rate = $('#duration option:selected').data('rate');
    var year = $('#duration option:selected').data('duration');
    var apport = $('#apport').val();

    var taegMonth = rate / 12;
    var duration = year * 12;
    var end = (monthly*(1-Math.pow((1+taegMonth),-duration)))/(taegMonth)
    if(!apport.trim()) {
      apport = 0;
    }
    var finalValue = Math.round(end) + parseInt(apport);

    $('#loanCapacity').html(Number(finalValue).toLocaleString('fr'));
    $('#loanCapacity').data('budget', finalValue);
  }
}

var buildBudgetInput = function () {
  var builder = new BudgetInputBuilder($(this));

  builder.setup();

  return builder;
};

export default buildBudgetInput;
